import { render, staticRenderFns } from "./TableLastRequestsList.vue?vue&type=template&id=08f515b4"
import script from "./TableLastRequestsList.vue?vue&type=script&lang=js"
export * from "./TableLastRequestsList.vue?vue&type=script&lang=js"
import style0 from "./TableLastRequestsList.vue?vue&type=style&index=0&id=08f515b4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f515b4')) {
      api.createRecord('08f515b4', component.options)
    } else {
      api.reload('08f515b4', component.options)
    }
    module.hot.accept("./TableLastRequestsList.vue?vue&type=template&id=08f515b4", function () {
      api.rerender('08f515b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableLastRequestsList.vue"
export default component.exports